import React from "react";
import { Download, Play, Smartphone, Phone, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function FinalCtaSection() {
  return <section data-section-id="260109" id="צרו-קשר" className="bg-background text-foreground py-24 px-4 md:px-8">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center">
        {}
        <div className="inline-flex items-center rounded-lg bg-accent px-4 py-1.5 text-sm font-medium text-accent-foreground mb-8">
          זמינות מיידית 24/7
        </div>

        {}
        <h2 className="font-default text-4xl md:text-5xl lg:text-[56px] font-bold text-foreground mb-6 leading-tight tracking-tight">
          צריכים מטפל סיעודי עכשיו?
        </h2>

        {}
        <p className="text-lg md:text-[20px] text-muted-foreground mb-10 max-w-2xl leading-relaxed">
          הורידו את האפליקציה שלנו והזמינו מטפל מקצועי ומיומן לביתכם תוך פחות מ-5 שעות. השקט הנפשי שלכם מתחיל כאן.
        </p>

        {}
        <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg px-8 py-6 text-lg h-auto mb-12 shadow-lg shadow-primary/20 transition-all hover:scale-105">
          <Link to="/ContactPage">
            <Download className="mr-2 size-5" />
            הורדת האפליקציה
          </Link>
        </Button>

        {}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8 w-full sm:w-auto">
          <Button asChild variant="outline" className="h-auto py-2.5 px-6 rounded-lg gap-3 border-border hover:bg-accent w-full sm:w-auto justify-start sm:justify-center">
            <Link to="https://apps.apple.com/il/app/siudy">
              <Smartphone className="size-7 text-foreground" />
              <div className="text-left">
                <div className="text-[10px] leading-none text-muted-foreground mb-1 uppercase tracking-wider">Download on the</div>
                <div className="text-sm font-semibold leading-none text-foreground">App Store</div>
              </div>
            </Link>
          </Button>
          
          <Button asChild variant="outline" className="h-auto py-2.5 px-6 rounded-lg gap-3 border-border hover:bg-accent w-full sm:w-auto justify-start sm:justify-center">
            <Link to="https://play.google.com/store/apps/details?id=com.siudy">
              <Play className="size-7 text-foreground" />
              <div className="text-left">
                <div className="text-[10px] leading-none text-muted-foreground mb-1 uppercase tracking-wider">GET IT ON</div>
                <div className="text-sm font-semibold leading-none text-foreground">Google Play</div>
              </div>
            </Link>
          </Button>
        </div>

        {}
        <div className="flex flex-wrap items-center justify-center gap-4 mb-12">
          <Button asChild variant="outline" className="rounded-lg px-6 py-4 h-auto border-primary/20 hover:border-primary transition-colors">
            <Link to="tel:050-000-0000">
              <Phone className="size-5 text-primary ml-2" />
              התקשרו עכשיו
            </Link>
          </Button>

          <Button asChild variant="outline" className="rounded-lg px-6 py-4 h-auto border-emerald-500/20 hover:border-emerald-500 transition-colors">
            <Link to="https://wa.me/972500000000">
              <MessageCircle className="size-5 text-emerald-500 ml-2" />
              וואטסאפ מיידי
            </Link>
          </Button>
        </div>

        {}
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mb-8 text-sm">
          <Link to="/" className="text-primary hover:underline font-medium">מטפל סיעודי</Link>
          <Link to="/NurseInTelAvivWithinHoursPage" className="text-primary hover:underline font-medium">מטפל סיעודי בתל אביב</Link>
          <Link to="/CaregiverServicePagesPage" className="text-primary hover:underline font-medium">מטפל סיעודי בבית</Link>
        </div>

        {}
        <p className="text-xs text-muted-foreground font-medium">
          זמין ב-App Store וב-Google Play • שירות בפריסה ארצית רחבה
        </p>
      </div>
    </section>;
}